var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.calloutType && _vm.refundableDays > 0)?_c('div',{staticClass:"guarantee-container"},[_c('GuaranteeText',{attrs:{"callout-type":_vm.calloutType,"refundable-days":_vm.refundableDays,"is-freebie":_vm.isFreebie,"interval":_vm.interval}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }